import { config } from "@msuite/katana";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

function createFirebase() {
	const app = initializeApp(config());
	const db = getFirestore(app);
	const auth = getAuth(app);
	const storage = getStorage(app);
	return { db, auth, storage };
}

const { db, auth, storage } = createFirebase();

export { auth, db, storage };
